import React, { createContext, useContext, useState } from "react";

const SidenavContext = createContext();

export const SidenavProvider = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <SidenavContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </SidenavContext.Provider>
  );
};

export const useSidenav = () => useContext(SidenavContext);
